import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: 'en',
    interpolation: {
      escapeValue: false
    },
    fallbackLng: 'en',
    react: {
      useSuspense: false
    }
  });

export default i18n;
